var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgQuotesPurple = function SvgQuotesPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 145,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#864DCF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87 85.5a22.275 22.275 0 01-4.969 14.013l-27.975 34.523c-2.966 3.66-8.885 1.563-8.885-3.148V98.294a5 5 0 00-5-5H5a5 5 0 01-5-5V5a5 5 0 015-5h70c6.627 0 12 5.373 12 12v73.5zM190 85.5a22.28 22.28 0 01-4.969 14.013l-27.975 34.523c-2.966 3.66-8.885 1.563-8.885-3.148V98.294a5 5 0 00-5-5H108a5 5 0 01-5-5V5a5 5 0 015-5h70c6.627 0 12 5.373 12 12v73.5z"
  }))));
};
export default SvgQuotesPurple;